import { Injectable } from '@angular/core';
import { TransportPauseStart } from '../model/out/transport-pause-start';
import { ServiceResponse } from '@sdbn/common';
import { Observable } from 'rxjs';
import { TransportPauseEnd } from '../model/out/transport-pause-end';
import { AppServerAPI } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class PauseTransportService {

  constructor(private appServerAPI: AppServerAPI) { }

  startPause(start: TransportPauseStart): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/transport/pause/start', start);
  }

  endPause(end: TransportPauseEnd): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/transport/pause/end', end);
  }

}
